import { CONSULT_CLOSED_NOTICE } from "@/constants/consult";
import { useConsultOpen } from "@/hooks/useConsultOpen";
import { Box } from "@chakra-ui/react";
import { BaseButton, call } from "goi_common";
import { baseColors, BaseStack } from "goi_common/src/design-system";

interface ConsultCallButtonProps {
  label: string;
  tel: string;
  /**
   * 상담 가능 시간에 쓰는 모양. primary 는 주황, secondary 는 검정, outlined 는 흰 배경 테두리.
   * 시간 외에는 모양과 상관없이 회색 비활성으로 보인다.
   */
  appearance: "primary" | "secondary" | "outlined";
  /** 상담 가능할 때 버튼 아래 붙는 안내 문구 */
  openNotice?: string;
  /** 눌렀을 때 전화를 걸기 전에 실행한다(이벤트 트래킹 등) */
  onClick?: () => void;
}

/**
 * 상담 전화 버튼. 상담 가능 시간(09:00~19:00 KST)에만 눌리고, 그 밖에는 비활성 버튼과
 * 빨간 안내 문구를 보여준다. 임종 접수 버튼에는 쓰지 않는다(시간 제한이 없다).
 */
export default function ConsultCallButton({
  label,
  tel,
  appearance,
  openNotice,
  onClick,
}: ConsultCallButtonProps) {
  const isOpen = useConsultOpen();

  return (
    <BaseStack spacing={8} width="100%">
      <BaseButton
        type={
          !isOpen
            ? "primary"
            : appearance === "outlined"
            ? "assistive_1"
            : appearance
        }
        outlined={isOpen && appearance === "outlined"}
        size="large"
        disabled={!isOpen}
        onClick={() => {
          onClick?.();
          call(tel);
        }}
      >
        <Box className="body_1_normal_sb">{label}</Box>
      </BaseButton>
      {isOpen && openNotice && (
        <Box
          className="label_1_r"
          color={baseColors.label_assistive_1}
          textAlign="center"
        >
          {openNotice}
        </Box>
      )}
      {!isOpen && (
        <Box
          className="caption_1_sb"
          color={baseColors.status_negative}
          textAlign="center"
          whiteSpace="pre-line"
        >
          {CONSULT_CLOSED_NOTICE}
        </Box>
      )}
    </BaseStack>
  );
}
